import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { IUserState } from './modules/user'
import { IScanforAcceptPacket } from './modules/store_scanforacceptpacket'
import { IScanforGetOn } from './modules/store_scanforgeton'
import { IScanforDepart } from './modules/store_scanfordepart'
import { IDeviceItems2} from './modules/store_deviceitems2'
import { IScanforAcceptPacketGetOn } from './modules/store_scanforacceptpacketgeton'
import { IScanforSixScan } from './modules/store_scanforsixscan'
import { IScanforBubblePackage } from './modules/store_scanforbubblepackage'
import { IScanforWeighBridge } from './modules/store_scanforweighbridge'
import { IScanforOutBound_GetOff } from './modules/store_scanforoutbound_getoff'
import { ISystemConfig } from './modules/store_systemconfig'
import { StoreCommon } from './modules/store_common'
import {store_commonModule} from "@/store/modules/store_common";


Vue.use(Vuex)

export interface IRootState {
  app: IAppState
  user: IUserState
  store_scanforacceptpacket:IScanforAcceptPacket
  store_scanforgeton:IScanforGetOn
  store_scanfordepart:IScanforDepart
  store_deviceitems2:IDeviceItems2
  store_scanforacceptpacketgeton:IScanforAcceptPacketGetOn
  store_scanforsixscan:IScanforSixScan
  store_scanforbubblepackage:IScanforBubblePackage
  store_scanforweighbridge:IScanforWeighBridge
  store_scanforoutbound_getoff:IScanforOutBound_GetOff
  store_systemconfig:ISystemConfig
  store_commonModule:StoreCommon
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
